import api from '../middleware/api';

export const loadState = () => {
    try {
        const serializedState = localStorage.getItem('hotelizer_settings');
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return undefined;
    }
};

export const saveState = (state, offline = false) => {
    try {
        const prevState = loadState();
        const finalState = prevState?Object.assign(prevState, state):state;
        const serializedState = JSON.stringify(finalState);
        localStorage.setItem('hotelizer_settings', serializedState);

        if(!offline){
            api.post(`/users/settings`, finalState)
                .then(response => {
                    
                }).catch(error => {
                    
            });
        }

    } catch (err) {
        console.log(`err:`, err)
        // Ignore write errors.
    }
};

export function deleteState() {
    const stateKey = 'hotelizer_settings';
    const storage = window.localStorage;
    try {
      storage.removeItem(stateKey);
      return true;
    } catch (error) {
      return false;
    }
}

export function isLocalStorageNameSupported() {
    const testKey = 'test';
    const storage = window.localStorage;
    try {
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
}